import { useCallback, useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import { Slide } from '@material-ui/core';

import Header from '../Header/header';

const useStyles = makeStyles((theme) => ({
  inVisible: {
    visibility: 'hidden',
  },
}));

const OnOffByScroll = (props) => {
  const classes = useStyles();
  const [isShown, setIsShown] = useState(true);
  const { place, targetRef } = props;

  const scrollEvent = useCallback(() => {
    const target = targetRef?.current;
    if (place === 'TopPageHeader' && target) {
      setIsShown(target.getBoundingClientRect().bottom > 0);
      return;
    }
    // Existing callers without a hero ref retain their scroll behavior.
    setIsShown(window.pageYOffset <= 1000);
  }, [place, targetRef]);

  useEffect(() => {
    scrollEvent();
    window.addEventListener('scroll', scrollEvent, { passive: true });
    window.addEventListener('resize', scrollEvent);
    return () => {
      window.removeEventListener('scroll', scrollEvent, { passive: true });
      window.removeEventListener('resize', scrollEvent);
    };
  }, [scrollEvent]);

  const headerElm = (isShown, flag) => {
    switch (flag) {
      case 'General':
        return (
          <div>
            <Header logo={true} icons={isShown} color="General" />
            {/* なぜ以下のelementを追加しないとSlideエフェクトが効かないのか理由がわからないが、これでうまくいく。 */}
            <span className={classes.inVisible}>hidden</span>
          </div>
        );
      case 'TopPageHeader':
        return (
          <div>
            <Header logo={!isShown} icons={isShown} />
            <span className={classes.inVisible}>hidden</span>
          </div>
        );
      default:
    }
  };

  switch (props.place) {
    case 'General':
      return <>{headerElm(isShown, 'General')}</>;
    case 'TopPageHeader':
      if (isShown) {
        return (
          <Slide direction="right" in={isShown} timeout={1000}>
            {headerElm(isShown, 'TopPageHeader')}
          </Slide>
        );
      } else {
        return (
          <Slide direction="right" in={!isShown} timeout={1000} appear={true}>
            {headerElm(isShown, 'TopPageHeader')}
          </Slide>
        );
      }
    default:
  }
};
export default OnOffByScroll;
